module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-notification-list row column"
  }, [_c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-045902c1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/RegistrationTokenList.vue
// module id = 2101
// module chunks = 1